<template>
  <div class="el-header-inner">
    <!-- Left -->
    <div class="el-header-inner--left">
      <el-button type="text" class="color-gray hide-sm" @click="toggleMenu" :title="$t('Toggle menu')">
        <i class="material-icons" v-if="isCollapsed">keyboard_arrow_right</i>
        <i class="material-icons" v-else>keyboard_arrow_left</i>
      </el-button>

      <el-button type="text" class="color-gray hide-md" @click="toggleAside" :title="$t('Toggle sidebar')">
        <i class="material-icons" v-if="asideIsVisible">clear</i>
        <i class="material-icons" v-else>menu</i>
      </el-button>
    </div>

    <!-- Center -->
    <div class="el-header-inner--center">
      <div class="logo-container">
        <!-- Logo -->
        <SVGLogo class="logo" />
      </div>
    </div>

    <!-- Right -->
    <div class="el-header-inner--right">
      <DropdownUserProfile />
    </div>
  </div>
</template>

<script>
import * as Browser from '@/services/browser';
import DropdownUserProfile from '@/components/Button/DropdownUserProfile.vue';
import SVGLogo from '@/assets/img/epal-deutschland-black.svg';

export default {
  name: 'AppHeader',

  components: {
    DropdownUserProfile,
    SVGLogo
  },

  computed: {
    asideIsVisible() {
      return this.$store.state.aside.visible;
    },

    isCollapsed() {
      return this.$store.state.menu.collapse;
    }
  },

  methods: {
    toggleAside() {
      this.$store.commit('aside/TOGGLE');

      // Show full menu after browser resize
      if (Browser.isDeviceXS() || Browser.isDeviceSM()) {
        if (this.asideIsVisible && this.isCollapsed) {
          this.$store.commit('menu/TOGGLE');
        }
      }
    },

    toggleMenu() {
      this.$store.commit('menu/TOGGLE');
      this.$store.commit('aside/TOGGLE');

      // Show full menu after browser resize
      if (this.asideIsVisible && this.isCollapsed) {
        this.$store.commit('menu/TOGGLE');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.el-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (min-width: $screen-md) {
    justify-content: flex-start;
  }

  &--center {
    @media screen and (min-width: $screen-md) {
      margin-left: 3rem;
    }
  }

  &--right {
    display: flex;
    align-items: center;

    @media screen and (min-width: $screen-md) {
      flex: 1 0 auto;
      justify-content: flex-end;
    }
  }
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 3rem;
  width: auto;
}

.logo-text {
  display: flex;
  flex-direction: column;
  margin-left: 0.2rem;
  font-family: $font-brand;
  letter-spacing: 1px;
  font-size: 0.8rem;

  @media screen and (min-width: $screen-md) {
    font-size: 1rem;
  }
}
</style>
